import PropTypes from 'prop-types';

import { classNames } from 'utils/format';

export default function ModalFooter({ children, className }) {
  return (
    <footer className={classNames('w-full bg-[#161618] p-4 sm:p-6', className)}>
      <div className="flex items-center justify-end gap-x-3">{children}</div>
    </footer>
  );
}
ModalFooter.displayName = 'Footer';

ModalFooter.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

ModalFooter.defaultProps = {
  className: '',
};
